/**
 * Browser polyfills for older WebView / Android environments.
 * This file is imported first in index.tsx to ensure polyfills
 * are in place before any library code runs.
 *
 * Fixes:
 * - BLOOM-FRONTEND-WEB-105: Array.prototype.at() missing on Chrome ≤ 80
 *   (web-vitals 5.x bundled in @sentry/react uses .at(-1) in CLS tracking)
 */

// Array.prototype.at — introduced in Chrome 92 / Node 16.6
// See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/at
if (typeof Array.prototype.at !== 'function') {
  // eslint-disable-next-line no-extend-native
  Array.prototype.at = function at(this: unknown[], index: number) {
    const len = this.length;
    // Spec: ToIntegerOrInfinity — truncate floats, coerce NaN/undefined to 0
    const k = Math.trunc(index) || 0;
    const relIndex = k < 0 ? len + k : k;
    if (relIndex < 0 || relIndex >= len) return undefined;
    return this[relIndex];
  };
}

// String.prototype.at — same era, polyfill for consistency
if (typeof String.prototype.at !== 'function') {
  // eslint-disable-next-line no-extend-native
  String.prototype.at = function at(this: string, index: number) {
    const len = this.length;
    // Spec: ToIntegerOrInfinity — truncate floats, coerce NaN/undefined to 0
    const k = Math.trunc(index) || 0;
    const relIndex = k < 0 ? len + k : k;
    if (relIndex < 0 || relIndex >= len) return undefined;
    return this[relIndex];
  };
}
